import * as React from 'react'
import { SVGProps } from 'react'
const SvgPerson = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 13C16.3281 13 19.8535 15.5778 19.9955 18.7979L20 19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19C4 15.6863 7.58172 13 12 13ZM12 3C14.2091 3 16 4.79086 16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3Z"
      fill="currentColor"
    />
  </svg>
)
export default SvgPerson
